const SHORT_TEXT_MAX_LENGTH = 255;
const LONG_TEXT_MAX_LENGTH = 100000000;
const MASK_MAP = {
  0: {
    regex: /\d/,
    type: 'digit',
    optional: false
  },
  9: {
    regex: /\d/,
    type: 'digit or can be excluded',
    optional: true
  },
  L: {
    regex: /[a-zA-Z]/,
    type: 'letter',
    optional: false
  },
  l: {
    regex: /[a-zA-Z]/,
    type: 'letter or can be excluded',
    optional: true
  },
  A: {
    regex: /[a-zA-Z0-9]/,
    type: 'digit or letter',
    optional: false
  },
  a: {
    regex: /[a-zA-Z0-9]/,
    type: 'digit, letter, or can be excluded',
    optional: true
  },
  '?': {
    regex: /.+/,
    type: 'digit, letter, space, symbol, etc.',
    optional: false
  }
};
const hasValue = value => !!value;

// TODO: if we can detect reference data override, we should disallow empty strings
//const hasValue = value => value !== null && !!String(value).trim()

const hasRequiredValue = previewEntry => {
  // TODO: We should have a shared place to store standard error messages...
  const errorMessage = 'This field is required';
  const {
    required,
    value
  } = previewEntry;
  if (required && !hasValue(value)) {
    return errorMessage;
  }
};
const isTooLong = previewEntry => {
  const {
    value,
    original_type_id,
    length
  } = previewEntry;
  const maxLength = `${original_type_id}` == '0' ? length || SHORT_TEXT_MAX_LENGTH : LONG_TEXT_MAX_LENGTH;
  if (value && value.length > maxLength) {
    return `The maximum length for this field is ${maxLength}`;
  }
};
const validateEmailFormat = previewEntry => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(previewEntry.value)) {
    return 'This field must contain a valid email address';
  }
};
const validateMaskFormat = ({
  mask,
  value
}) => {
  let maskCharsToCheck = mask;
  let valueCharsToCheck = value;
  let startingPosition = 1;

  // For masks with wild cards, only the non-wild-card characters in the mask are checked
  const wildCardPosition = mask.indexOf('*');
  if (wildCardPosition === 0) {
    maskCharsToCheck = maskCharsToCheck.slice(1);
    valueCharsToCheck = valueCharsToCheck.slice(-maskCharsToCheck.length);
    startingPosition = value.length - valueCharsToCheck.length + 1;
  } else if (wildCardPosition === mask.length - 1) {
    maskCharsToCheck = maskCharsToCheck.slice(0, -1);
    valueCharsToCheck = valueCharsToCheck.slice(0, maskCharsToCheck.length);
  }
  const requiredMaskCharacters = maskCharsToCheck.split('').filter(char => MASK_MAP[char].optional === false);
  // The value should have at least as many characters as the mask requires
  if (requiredMaskCharacters.length > valueCharsToCheck.length) {
    return `Input does not match mask. ${requiredMaskCharacters.length} characters are required.`;
  }
  // When there are no wild cards, the value should not be longer than the mask
  if (wildCardPosition === -1 && value.length > mask.length) {
    return `Input does not match mask. A maximum of ${mask.length} characters are allowed.`;
  }
  let maskError;
  let index = 0;
  while (index < maskCharsToCheck.length) {
    const maskChar = maskCharsToCheck.charAt(index);
    const actualChar = valueCharsToCheck.charAt(index);
    const position = startingPosition + index;
    const {
      regex,
      type,
      optional
    } = MASK_MAP[maskChar];
    if ((!optional || optional && actualChar) && !regex.test(actualChar)) {
      maskError = actualChar ? `Input does not match mask. The ${actualChar === ' ' ? 'space' : actualChar} in position ${position} needs to be a ${type}.` : `Input does not match mask. A ${type} in position ${position} is required.`;
      break;
    }
    index++;
  }
  return maskError;
};
const validateShortText = previewEntry => {
  const {
    original_type_id,
    style,
    mask
  } = previewEntry;
  const hasEmailFormat = original_type_id == 0 && [10, 11].includes(parseInt(style) || 0);
  let errorMessage;
  if (hasEmailFormat) {
    errorMessage = validateEmailFormat(previewEntry);
  } else if (mask) {
    errorMessage = validateMaskFormat(previewEntry);
  }
  return errorMessage ? errorMessage : isTooLong(previewEntry);
};
const validateLongText = previewEntry => isTooLong(previewEntry);
const validateFormat = previewEntry => {
  let errorMessage;
  const {
    value,
    original_type_id
  } = previewEntry;
  if (value) {
    if (original_type_id == 0) {
      errorMessage = validateShortText(previewEntry);
    } else if (original_type_id == 8) {
      errorMessage = validateLongText(previewEntry);
    }
  }
  return errorMessage;
};
export default [{
  validation: hasRequiredValue,
  type: 'required'
}, {
  validation: validateFormat,
  type: 'format'
}];